require('./sectionTemplateEditorNav.i18n.json');
require('./sectionTemplateEditorNav.tpl.html');
require('./sectionTemplateEditorNavController.js');

const SectionTemplateEditorNavComponent = {
    templateUrl: '/configuration/sectionTemplateEditor/nav/sectionTemplateEditorNav.tpl.html',
    controller: 'sectionTemplateEditorNavController',
    bindings: {}
};

angular.module('ums.configuration')
    .component('uiSectionTemplateEditorNav', SectionTemplateEditorNavComponent);
